import _DatabaseModel from "./_DatabaseModel";

class Threat extends _DatabaseModel {
  static model = "threat";
  static showSize = 8;
  static editDialogComponent = "threat-edit-dialog";
  static tableHeaders = [{ textKey: "form.label.name", value: "name" }];
  static createNewObject = {
    object: { confidentiality: true, integrity: true, availability: true },
    params: {},
  };

  static show = {
    buttons: ["edit"],
    reloadingModels: ["vulnerability"],
  };

  static filter = {
    parts: {
      fields: ["name", "description", "time_filter"],
      extended_fields: [],
      time_filter: ["created_at", "updated_at"],
    },
  };

  static operations = ["export"];

  static basicInfo(object) {
    return [
      {
        labelKey: "form.label.threat_category_id",
        value: object.threat_category?.name,
        type: "plain",
      },
      {
        labelKey: "threat.label.accidental",
        value: object.accidental,
        type: "boolean",
      },
      {
        labelKey: "threat.label.intentional",
        value: object.intentional,
        type: "boolean",
      },
      {
        labelKey: "threat.label.environmental",
        value: object.environmental,
        type: "boolean",
      },
      {
        labelKey: "threat.label.confidentiality",
        value: object.confidentiality,
        type: "boolean",
      },
      {
        labelKey: "threat.label.integrity",
        value: object.integrity,
        type: "boolean",
      },
      {
        labelKey: "threat.label.availability",
        value: object.availability,
        type: "boolean",
      },
      {
        labelKey: "form.label.created_at",
        value: object.created_at,
        type: "date_time",
      },
    ];
  }

  static submenuActions = [
    this.commonActions.duplicate,
    this.commonActions.openActivities,
    this.commonActions.delete,
  ];

  static tabs = [this.detailTab];
}

export default Threat;
